import { changePasswordAction, getLanguages, updateSettingsProperty, getAccessRequestsAction } from './actions';
import { defaultListParams, listReducer } from '../../utils/crudUtils';

export const key = 'Settings';

export const initialState = {
  loading: false,
  error: {},
  availableLanguages: [],
  accessRequests: defaultListParams,
};

const settingsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case getLanguages.TRIGGER:
    case updateSettingsProperty.TRIGGER:
    case changePasswordAction.TRIGGER:
      return {
        ...state,
        loading: true,
      };

    case getLanguages.FAILURE:
    case updateSettingsProperty.FAILURE:
    case changePasswordAction.FAILURE:
      return {
        ...state,
        loading: false,
        error: { ...payload },
      };

    case getLanguages.SUCCESS:
      return {
        ...state,
        loading: false,
        availableLanguages: { ...payload },
      };

    case updateSettingsProperty.SUCCESS:
      return {
        ...state,
        loading: false,
      };

    case changePasswordAction.SUCCESS:
      return {
        ...state,
        loading: false,
      };

    case getAccessRequestsAction.TRIGGER:
    case getAccessRequestsAction.FAILURE:
    case getAccessRequestsAction.SUCCESS:
      return listReducer(state, type, payload, 'accessRequests');

    default:
      return state;
  }
};

export default settingsReducer;
